import { useGetMerchantOrderQuery, usePageSettings } from '@p2p/services';
import { useParams } from 'react-router-dom';

import { TransferForm } from './TransferForm';

export const TransferFormPage = () => {
  const { id = '', bankId = '' } = useParams<{ id: string; bankId: string }>();
  const { isLoading, data: order } = useGetMerchantOrderQuery(id, { skip: !id });
  const { data: pageSettings, isLoading: isLoadingPageSettings } = usePageSettings({
    order,
  });

  if (isLoading || isLoadingPageSettings || !order || !pageSettings) {
    return null;
  }

  return <TransferForm id={id} order={order} bankId={Number(bankId)} pageSettings={pageSettings} />;
};
